module.exports = __webpack_public_path__ + "img/ataviti-emblem-white.898a7beb.svg";